import * as url from "url";

import * as dates from "../../reducers/changeTimePeriod";
import * as viewModes from "../../reducers/viewModes";

import { ILinkParams } from "../../classes/linkParams";

const SHOWCALENDAR = "showCalendar";
const PORTALID = "portalId";
const PAGEID = "pageId";
const OBJECTID = "objectId";
const CONTEXTID = "contextId";
const PARENTID = "parentId";
const ACTION = "action";
const OBJECTTYPE = "objectType";
const CURRENTDATE = "currentDate";
const TODAYSDATE = "todaysDate";
const VIEW = "view";
const CALENDARNAME = "CalendarName";
const PAGENAME = "PageName";
const FIRSTDAY = "firstDay";
const LASTDAY = "lastDay";
const RETURNTO = "returnTo";
const REF = "ref";
const ALERTTYPE = "alertType";

export const getLinkToNETPage = (event: any, linkParams: ILinkParams): string => {

  if (event) { event.preventDefault(); }
  const location = window.location.toString();
  const theUrl = url.parse(location, true);

  let SUFFIX = "";
  if (linkParams.baseURL !== "/alerts/AlertAE.aspx") {
    SUFFIX = "." + linkParams.portletInstanceId; // Have to add portletInstanceId to the keys for some reason, except for the Email Alerts Subscribe link.
  }

  const newQuery = {}; // This will hold the items that will be in the final URL's querystring.

  if (theUrl.query[SHOWCALENDAR]) { newQuery[SHOWCALENDAR] = theUrl.query[SHOWCALENDAR]; } // Preserve 'showCalendar=modern' if that's in the url.

  if (linkParams.portalId) { newQuery[PORTALID] = linkParams.portalId; }
  if (linkParams.pageId) { newQuery[PAGEID] = linkParams.pageId; }
  if (linkParams.objectId) { newQuery[OBJECTID + SUFFIX] = linkParams.objectId; }
  if (linkParams.contextId) { newQuery[CONTEXTID + SUFFIX] = linkParams.contextId; }
  if (linkParams.parentId) { newQuery[PARENTID + SUFFIX] = linkParams.parentId; }
  if (linkParams.action) { newQuery[ACTION + SUFFIX] = linkParams.action; }
  if (linkParams.objectType) { newQuery[OBJECTTYPE + SUFFIX] = linkParams.objectType; }
  if (linkParams.currentDate) { newQuery[CURRENTDATE] = dates.formatYearMonthDay(linkParams.currentDate); }
  if (linkParams.todaysDate) { newQuery[TODAYSDATE] = dates.formatYearMonthDay(linkParams.todaysDate); }
  if (linkParams.viewMode) { newQuery[VIEW] = viewModes.ConvertToCMSViewMode(linkParams.viewMode); }
  if (linkParams.calendarName) { newQuery[CALENDARNAME] = linkParams.calendarName; }
  if (linkParams.pageName) { newQuery[PAGENAME] = linkParams.pageName; }
  if (linkParams.firstDay) { newQuery[FIRSTDAY] = dates.formatYearMonthDayNoSeperator(linkParams.firstDay); }
  if (linkParams.lastDay) { newQuery[LASTDAY] = dates.formatYearMonthDayNoSeperator(linkParams.lastDay); }
  if (linkParams.alertType) { newQuery[ALERTTYPE] = linkParams.alertType; }
  if (linkParams.returnTo) { newQuery[RETURNTO] = linkParams.returnTo; }
  if (linkParams.ref) { newQuery[REF] = linkParams.ref; }

  const newURLstring = url.format({
    hash: theUrl.hash,
    host: theUrl.host,
    pathname: linkParams.baseURL,
    port: theUrl.port,
    protocol: theUrl.protocol,
    query: newQuery,
  });

  // displayLinkDetailsAlert(linkParams.linkName, location, newURLstring);

  return newURLstring;
};

const displayLinkDetailsAlert = (linkName: string, location: string, newURLString: string) => {

  const theUrl = url.parse(location, true);

  const linebreak = "\n";
  let locationDetails = linkName + linebreak + linebreak;
  locationDetails += "Location: " + location + linebreak;
  locationDetails += "Protocol: " + theUrl.protocol + linebreak;
  locationDetails += "Host name: " + theUrl.hostname + linebreak;
  locationDetails += "Port: " + theUrl.port + linebreak;
  locationDetails += "Pathname: " + theUrl.pathname + linebreak;
  locationDetails += "Search: " + theUrl.search + linebreak;
  locationDetails += "Hash: " + theUrl.hash + linebreak;

  locationDetails += linebreak;

  locationDetails += linebreak;

  locationDetails += "New URL: " + newURLString;

  alert(locationDetails);
};
